import { useRouter } from 'next/router'
import React from 'react'
import TopoLines from '#/assets/images/car/topo-lines.svg'
import SvgArrow from '#/assets/images/icons/arrow-circle-o-right.svg'
import Button from '#/components/Button'
import Link from '#/components/Link'
// import { initialState as initPreferences } from '#/store/reducers/preferences'
import { urlWithQuery } from '#/utils/url'

type mlsInfoProps = {
  [key: string]: {
    titleAbr?: string
    title: string
    height?: string
    width?: string
  }
}

interface BannerProps {
  section: string
  domain: string
  mlsInfo: mlsInfoProps
  mapPage: { href: string; rel: string }
  authenticated: boolean
  logCTAClick: (x: string) => void
  overlap: boolean
}

export default function DiscountBanner({
  section,
  domain,
  mlsInfo,
  mapPage,
  authenticated,
  logCTAClick,
  overlap
}: BannerProps) {
  const mls = mlsInfo[domain]
  const router = useRouter()

  return (
    <div className='mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8'>
      <div
        className={`${
          overlap && '-mt-40'
        } relative flex h-56 items-center overflow-hidden rounded-t-2xl bg-primary shadow-xl sm:h-56 sm:rounded-2xl`}
      >
        <div className='w-full px-6 sm:w-2/3 sm:pb-12 sm:pl-16 sm:pt-10 lg:py-16 lg:pr-0 xl:px-24 xl:py-16'>
          <div className='hidden sm:block lg:self-center'>
            <span className='block max-w-sm font-semibold text-white sm:text-xl'>
              {mls.titleAbr || mls.title}
              {' '}
              Members
            </span>
          </div>

          <div className='block text-white sm:hidden'>
            <div className='block py-1 text-center text-xl font-medium'>
              {mls.titleAbr || mls.title}
              {' '}
              Members
            </div>
          </div>
        </div>
        <TopoLines className='absolute -right-72 -top-24 hidden pl-80 pt-12 opacity-70 sm:-right-96 sm:-top-32 sm:block sm:pb-24 sm:pl-24 sm:pt-6 md:-right-48 lg:-right-2' />
        <TopoLines className='opacity-00 absolute -ml-56 mt-40 rotate-6 p-48 sm:hidden' />
        <div className='z-10 ml-auto hidden h-96 w-0 items-center rounded-l-full bg-header shadow-inner sm:flex sm:w-72 xl:w-96'>
          <div className='mx-auto'>
            {authenticated ? (
              <Link {...mapPage}>
                <Button
                  className='whitespace-nowrap rounded-full bg-secondary px-6 py-3 text-base text-white shadow-inner'
                  onClick={() => logCTAClick(section)}
                >
                  Go to Map
                </Button>
              </Link>
            ) : (
              <Link
                className='whitespace-nowrap rounded-full bg-secondary px-6 py-3 text-base text-white shadow-inner'
                {...urlWithQuery(router, { auth: 'signup', pn: 'wfg' })}
                rel='nofollow'
                onClick={() => logCTAClick(section)}
              >
                Sign Up!
                <SvgArrow />
              </Link>
            )}
          </div>
        </div>
      </div>
      <div className='flex justify-center rounded-b-2xl bg-header py-7 sm:hidden'>
        {authenticated ? (
          <Link {...mapPage}>
            <Button
              className='whitespace-nowrap rounded-full bg-secondary px-8 py-3 text-sm text-white shadow-inner sm:py-4 sm:text-xl'
              onClick={() => logCTAClick(section)}
            >
              Go to Map
            </Button>
          </Link>
        ) : (
          <Link
            className='whitespace-nowrap rounded-full bg-secondary px-8 py-3 text-sm text-white shadow-inner sm:py-4 sm:text-xl'
            {...urlWithQuery(router, { auth: 'signup', pn: 'wfg' })}
            rel='nofollow'
            onClick={() => logCTAClick(section)}
          >
            Sign Up!
            <SvgArrow />
          </Link>
        )}
      </div>
    </div>
  )
}
